import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKarlsruherverkehrsverbundComponent } from './simple-icons-karlsruherverkehrsverbund.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKarlsruherverkehrsverbundComponent ],
    exports:      [ SimpleIconsKarlsruherverkehrsverbundComponent ],
    bootstrap:    []
})
export class SimpleIconsKarlsruherverkehrsverbundModule {}
